import { GetComplianceActionsSchemaContract } from 'schemas/GetComplianceActionsSchema';
import {
  actionStatusesMap,
  complianceActionsMap,
} from 'components/RunPayroll/ComplianceActions/data';
import { ComplianceAction } from 'components/RunPayroll/ComplianceActions/contexts/ComplianceActionsContext';

export const isCompliancePaymentInProgress = ({
  actionsApiResponse,
}: {
  actionsApiResponse?: GetComplianceActionsSchemaContract['actions'];
}) => {
  let isAnyActionInProgress = false;
  if (actionsApiResponse) {
    const actionNames = Object.keys(actionsApiResponse) as ComplianceAction[];

    for (const actionName of actionNames) {
      if (actionName === complianceActionsMap.payPt) {
        const action = actionsApiResponse[actionName];
        const subActionNames = Object.keys(action);
        const inProgressSubActions = subActionNames.find(
          (subActionName) => action[subActionName].status === actionStatusesMap.inProgress,
        );
        if (inProgressSubActions) {
          isAnyActionInProgress = true;
          break;
        }
      }
      const action = actionsApiResponse[actionName];
      if (action.status === actionStatusesMap.processing) {
        isAnyActionInProgress = true;
        break;
      }
    }
  }
  return isAnyActionInProgress;
};

export const getKAPTWindowNotOpenMessage = (payrollMonth: string, kaPtWindowOpenDay: number) => {
  const [year, month] = payrollMonth.split('-').map(Number);
  const currentPayroll = new Date(year, month - 1, 1).toLocaleString('default', { month: 'long' });

  const windowOpenMonth = new Date(year, month, kaPtWindowOpenDay).toLocaleString('default', { month: 'long' });

  return `As per Karnataka PT rules, PT payment for ${currentPayroll} payroll month will be available from the ${kaPtWindowOpenDay} ${windowOpenMonth}. Please retry after that date.`;
};
